var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
var Seat = /** @class */ (function (_super) {
    __extends(Seat, _super);
    function Seat() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            if (!_this.props.isReserved) {
                _this.props.selectSeat();
            }
        };
        return _this;
    }
    Seat.prototype.render = function () {
        var _a = this.props, seat = _a.seat, isSelected = _a.isSelected, tooltip = _a.tooltip, isEnabled = _a.isEnabled, isReserved = _a.isReserved, orientation = _a.orientation, offsetLeft = _a.offsetLeft, offsetRight = _a.offsetRight, offsetTop = _a.offsetTop, offsetBottom = _a.offsetBottom, showNumber = _a.showNumber, onlyHandicapped = _a.onlyHandicapped, seatNumber = _a.seatNumber;
        var classname = 'selectable seat';
        if (isSelected) {
            classname += ' seat--selected';
        }
        if (!isSelected && isEnabled && !isReserved) {
            if (onlyHandicapped) {
                classname += ' seat--enabled--handicapped';
            }
            else {
                classname += ' seat--enabled';
            }
        }
        if (isReserved) {
            classname += ' seat--reserved';
        }
        classname += " seat--".concat(!orientation ? 'none' : orientation);
        return (React.createElement("div", { "data-tip": tooltip, className: classname, onClick: this.handleClick, "data-seat": JSON.stringify(seat), style: {
                borderColor: onlyHandicapped ? '#0377F4' : 'inherit',
                borderWidth: onlyHandicapped ? 3 : 'inherit',
                borderStyle: onlyHandicapped ? 'solid' : 'inherit',
                marginLeft: "".concat(offsetLeft || 2, "px"),
                marginRight: "".concat(offsetRight || 2, "px"),
                marginTop: "".concat(offsetTop || 2, "px"),
                marginBottom: "".concat(offsetBottom || 2, "px"),
            } },
            tooltip ? React.createElement(ReactTooltip, __assign({}, this.props.tooltipProps)) : null,
            showNumber && React.createElement("span", { className: "seat__number" }, this.props.seatNumber)));
    };
    Seat.defaultProps = {
        isSelected: false,
        showNumber: false
    };
    return Seat;
}(Component));
export default Seat;



//////////////////
// WEBPACK FOOTER
// ./src/components/Seatmap/SeatPicker/Seat.tsx
// module id = 1273
// module chunks = 0